module.exports = __webpack_public_path__ + "img/monitoring-tow-track.15445f19.svg";